import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import backgroundImage from '../assets/images/bg_3_xs.webp'

const Profile: React.FC = () => {
	const { profile } = useAuth()
	const navigate = useNavigate()

	useEffect(() => {
		const handleUnauthorized = () => {
			navigate('/')
		}

		window.addEventListener('unauthorized', handleUnauthorized)
		return () => {
			window.removeEventListener('unauthorized', handleUnauthorized)
		}
	}, [navigate])

	if (!profile) {
		return <div className='text-center text-red-500'>Profile not found</div>
	}

	return (
		<div
			className='min-h-screen text-white bg-cover bg-center bg-fixed p-6'
			style={{
				backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${backgroundImage})`,
			}}
		>
			<h2 className='text-3xl font-semibold text-yellow-400 mb-6'>Profile</h2>
			<div className='bg-gray-800 bg-opacity-90 p-6 rounded-lg shadow-lg'>
				<h3 className='text-2xl font-bold text-red-400'>{profile.username}</h3>
				<h4 className='text-xl font-semibold text-yellow-400 mt-6 mb-4'>
					Characters
				</h4>
				{profile.characters.length > 0 ? (
					<ul className='space-y-4'>
						{profile.characters.map((character, index) => (
							<li key={index} className='bg-gray-700 p-4 rounded-lg'>
								<Link
									to={`/character/${character.Name}`}
									className='text-red-400 hover:text-red-500 font-semibold'
								>
									{character.Name}
								</Link>
								<p className='text-gray-300 mt-1'>
									Level: <span className='text-white'>{character.CLevel}</span>
								</p>
								<p className='text-gray-300 mt-1'>
									Class: <span className='text-white'>{character.Class}</span>
								</p>
								<p className='text-gray-300 mt-1'>
									Reset Count:{' '}
									<span className='text-white'>
										{character.ResetCount || 0}
									</span>
								</p>
								<p className='text-gray-300 mt-1'>
									Guild:{' '}
									<span className='text-white'>
										{character.Guild || 'None'}
									</span>
								</p>
								<p className='text-gray-300 mt-1'>
									Status:{' '}
									<span
										className={
											character.Online ? 'text-green-400' : 'text-red-400'
										}
									>
										{character.Online ? 'Online' : 'Offline'}
									</span>
								</p>
							</li>
						))}
					</ul>
				) : (
					<p className='text-gray-400'>No characters found.</p>
				)}
			</div>
		</div>
	)
}

export default Profile
